import { render, staticRenderFns } from "./HelpYoutubePlayer.vue?vue&type=template&id=906f6066&scoped=true"
import script from "./HelpYoutubePlayer.vue?vue&type=script&lang=js"
export * from "./HelpYoutubePlayer.vue?vue&type=script&lang=js"
import style0 from "./HelpYoutubePlayer.vue?vue&type=style&index=0&id=906f6066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906f6066",
  null
  
)

export default component.exports